interface PassoProntoProps {
  primeiroNome: string;
  mensagem: string;
  registro?: string;
  aoFechar: () => void;
}

// Passo 4 — confirmação.
export default function PassoPronto({
  primeiroNome,
  mensagem,
  registro,
  aoFechar,
}: PassoProntoProps) {
  return (
    <div className="rounded-2xl border border-background-200 bg-white p-5 text-center">
      <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-success-100 text-success-600">
        <i className="ri-checkbox-circle-fill text-4xl" aria-hidden />
      </span>

      <h2 className="mt-4 text-[20px] font-extrabold text-foreground-950">
        {primeiroNome ? `Pronto, ${primeiroNome}!` : 'Pronto!'}
      </h2>
      <p className="mt-2 text-[15px] leading-relaxed text-foreground-700">
        {mensagem || 'Recebemos as informações das suas crianças.'}
      </p>
      {registro && <p className="mt-2 text-[13px] text-foreground-500">{registro}</p>}

      <div className="mt-5 rounded-xl border border-warning-300 bg-warning-50 p-3.5 text-left">
        <p className="flex items-start gap-2 text-[14px] leading-relaxed text-warning-900">
          <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
            <i className="ri-medicine-bottle-line" aria-hidden />
          </span>
          <span>
            Leve os remédios na embalagem original, com o nome da criança, a dose e os horários, e
            entregue à equipe das crianças na chegada.
          </span>
        </p>
      </div>

      <button
        type="button"
        onClick={aoFechar}
        className="aperta mt-5 flex h-[52px] w-full cursor-pointer items-center justify-center whitespace-nowrap rounded-xl bg-primary-500 px-5 text-[16px] font-bold text-white hover:bg-primary-600"
      >
        Fechar
      </button>
    </div>
  );
}